import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => ({
  ...filter,
  people: [...(filter.people || []), Array.from(insights).map((insight) => insight.name)]
})

const generatePeopleInsightStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})
export default generatePeopleInsightStrategy
